// Cowork composer (E1) — open ANY folder as the session's working root, git optional.
//
// Fixes "criei o repo linkedin e abriu o Apolo": picking a repo only set a UI
// label (code.ui.github_repo), never the session's actual root (worktree_path ||
// directory). This picks a folder via the Electron native dialog and REBINDS the
// session to it as mode='direct' (a plain folder; the backend clears worktree_path
// so sessionRoot falls through to the picked directory). Git stays optional — if
// the folder has a .git, GitConnectionBar surfaces it; if not, the git UI hides.
//
// `rebind` is injected (the store's updateCodeSession) so this is unit-testable
// without the store. Returns { ok, path, isGit } | { ok:false, error }.

import { hasElectronBridge } from './electronBridge.js';

export async function openFolderForSession(sessionId, { rebind, pick } = {}) {
  const picker = pick
    || (hasElectronBridge() && typeof window?.apolo?.repo?.pickFolder === 'function'
      ? window.apolo.repo.pickFolder
      : null);
  if (!picker) {
    return { ok: false, error: 'Abrir pasta só funciona no app (Electron).' };
  }
  if (!sessionId) return { ok: false, error: 'Sem sessão ativa para abrir a pasta.' };
  if (typeof rebind !== 'function') return { ok: false, error: 'Sem como vincular a pasta.' };

  let picked;
  try {
    picked = await picker();
  } catch (e) {
    return { ok: false, error: e?.message || 'Falha ao abrir o seletor de pasta.' };
  }
  if (!picked?.ok || !picked.path) {
    return { ok: false, error: picked?.error || 'Seleção cancelada.' };
  }

  // Rebind the session root to the picked folder, git-optional (mode='direct').
  const res = await rebind(sessionId, { directory: picked.path, mode: 'direct' });
  if (!res?.ok) return { ok: false, error: res?.error || 'Falha ao vincular a pasta.' };
  return { ok: true, path: picked.path, isGit: !!picked.isGit };
}
